import React, { useEffect, useState } from "react";
import { Input } from "@material-tailwind/react";
import { AiOutlineSearch } from "react-icons/ai";
import { GrFormNext } from "react-icons/gr";
import Pagination from "@/components/pagination";
import { handleDay } from "@/utils/helper";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import VoucherInfo from "@/components/voucherinfo";
import { useSelector } from "react-redux";
import { getUserData } from "@/redux/slices/userSlices";
import Api from "@/components/api/api";
import ToastProvider from "@/hooks/useToastProvider";
import { ListVoucher, PaginationType } from "@/utils/interface.global";
import SearchComponents from "@/components/search";

const List = () => {
  const user = useSelector(getUserData);
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit] = useState(6);
  const [eventData, setEventData] = useState<string>("");
  const [data, setData] = useState<null | Array<ListVoucher>>([]);
  const [pagination, setPagination] = useState<null | PaginationType>(null);
  const [startDate, setStartDate] = useState(handleDay("2023-05-01"));
  const [endDate, setEndDate] = useState(handleDay(String(new Date())));
  const [voucherID, setVoucherID] = useState<null | string>(
    !searchParams.get("voucherID") ? null : searchParams.get("voucherID")
  );

  const fetchDataVoucher = async () => {
    try {
      const reqUrl = "/get-list-voucher";
      const params = {
        key: user.key_login,
        user_id: user.id,
        voucher_code: eventData,
        start_date: startDate,
        end_date: endDate,
        currentPage: currentPage,
        limit: limit,
      };
      const res = await Api.post(reqUrl, params);
      if (!res.data.status)
        return ToastProvider({ type: "error", content: res.data.message });
      setData(res.data.data);
      setPagination(res.data.pagination);
    } catch (error) {
      ToastProvider({
        type: "error",
        content: "Có lỗi xảy ra trong quá trình tải data. Vui lòng thử lại",
      });
    }
  };

  const handleInfo = (ID: number) => {
    setVoucherID(String(ID));
    const activatedTabs = searchParams.get("activatedTabs");
    if (activatedTabs) {
      const options = {
        search: location.search + `&voucherID=${ID}`,
      };
      navigate(options, { replace: true });
    }
  };

  const onChangeEventData = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEventData(event.target.value);
  };
  const handleSearchFunction = () => {
    //eventData, startDate, endDate
    fetchDataVoucher();
  };

  useEffect(() => {
    fetchDataVoucher();
  }, [currentPage]);

  return (
    <div className="list-container">
      {!voucherID ? (
        <>
          <SearchComponents
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            placeHolder="Mã Phiếu Thay Dầu"
            nameInput="Nhập Mã Phiếu Thay Dầu"
            dataInput={eventData}
            onChangeFunc={onChangeEventData}
            searchFunc={handleSearchFunction}
          />
          <div className="list-table">
            <div className="flex justify-between items-center">
              <h1 className="text-sm font-bold text-red-500">
                Số Phiếu Thay Dầu Đã Kích Hoạt:{" "}
                {pagination ? pagination.total : 0}
              </h1>
              {/* <div className="inline-flex items-center gap-1 cursor-pointer text-red-500 font-bold hover:underline">
            <p className="text-sm">Xuất File</p>
            <BsPrinterFill />
          </div> */}
            </div>
            <div className="flex flex-col pt-4 overflow-x-auto">
              <table className="min-w-full text-left text-sm font-light">
                <thead className="border-b font-medium dark:border-neutral-500">
                  <tr>
                    <th scope="col" className="px-6 py-2">
                      #
                    </th>
                    {/* <th scope="col" className="px-6 py-2 text-left">
                      Họ Và Tên
                    </th> */}
                    <th scope="col" className="px-6 py-2 text-center">
                      Mã Phiếu Thay Dầu
                    </th>
                    <th scope="col" className="px-6 py-2 text-center">
                      Thời Gian Kết Thúc
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.map((res: ListVoucher, index: number) => (
                      <tr
                        key={index}
                        className="border-b transition duration-300 ease-in-out hover:bg-white hover:text-red-500 hover:font-bold cursor-pointer"
                        onClick={() => handleInfo(res.id)}
                      >
                        <td className="whitespace-nowrap px-6 py-2 font-medium">
                          {res.id}
                        </td>
                        {/* <td className="whitespace-nowrap px-6 py-2 font-medium">
                          {res.kh_name}
                        </td> */}
                        <td className="whitespace-nowrap px-6 py-2 font-medium text-center">
                          {res.code_voucher}
                        </td>
                        <td className="whitespace-nowrap px-6 py-2 font-medium text-center">
                          {res.time_active}
                        </td>
                        <td className="whitespace-nowrap py-2">
                          <GrFormNext />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="list-pagination">
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pagination={pagination}
            />
          </div>
        </>
      ) : (
        <VoucherInfo isEdited={true} setVoucherID={setVoucherID} />
      )}
    </div>
  );
};

export default List;
